
function init() {
    document.querySelectorAll('.js-pass-confirmation').forEach(el => {
        const checkbox = el.querySelector('.js-pass-confirmation__checkbox');
        const button = el.querySelector('.js-pass-confirmation__submit');
        const input = el.querySelector('.js-pass-confirmation__pass-input');

        let isValid = false;
        let isChecked = false;

        if (!checkbox || !button || !input) {
            return;
        }

        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                isChecked = true;

                if (input.value === '') {
                    input.focus();
                }
            } else {                
                isChecked = false;
            }

            toggleElements();
        });

        // Input validation
        const errorEl = el.querySelector('.js-pass-confirmation__validation-error');

        input.addEventListener('input', () => {
            toggleElements();
        });

        const checkValidation = () => {
            const val = input.value;
            const validLength = val.length >= 5 && val.length <= 16;
            const validChars = /^[0-9]+$/g.test(val);

            isValid = validChars && validLength;

            if (val.length > 0) {
                if (!validChars) {
                    errorEl.innerText = 'Only numeric characters are allowed.';
                } else if (!validLength) {
                    errorEl.innerText = 'Must be between 5 and 16 characters long.';
                } else {
                    errorEl.innerText = '';
                }
            } else {
                errorEl.innerText = '';
            }
        }

        const toggleElements = () => {
            checkValidation();

            if (isChecked && isValid) {
                button.classList.remove('bg-grey');
                button.classList.remove('opacity-25');
                button.classList.add('bg-black');

                button.disabled = false;
            } else {
                button.classList.remove('bg-black');
                button.classList.remove('opacity-25');
                button.classList.add('bg-grey');

                button.disabled = true;
            }
        }

        
    });
}

init();


// WEBPACK FOOTER //
// ./src/js/_lounge-archive.js